import {
  Box,
  CircularProgress,
  IconButton,
  Popover,
  styled,
  Theme,
  Typography,
} from '@mui/material';

export const CustomSizedEditIcon = styled(IconButton)(
  ({ theme }) => `
  svg {
    width: 16px;
    height: 16px;
  }
  padding: 5px;
  margin: auto 0;
  color: ${theme.palette.brand.black};
  `,
);

export const CustomSizedDeleteIcon = styled(CustomSizedEditIcon)(
  ({ theme }) => `
  color: ${theme.palette.error.main};
  `,
);

const getEventBorderColor = (
  theme: Theme,
  $isDefaultAssembly: boolean,
  $isSelected: boolean,
) => {
  if (!$isSelected) {
    return $isDefaultAssembly
      ? theme.palette.brand.mediumGrey
      : theme.palette.primary.light;
  }

  return $isDefaultAssembly
    ? theme.palette.brand.charcoal
    : theme.palette.primary.main;
};

export const EventNameWrapper = styled(Box)(
  ({ theme, $isDefaultAssembly, $isSelected }) =>
    `
  cursor: pointer;
  display: flex;
  flex-direction: row;
  min-height: 38px;
  align-items: center;
  padding: 2px 4px 0 16px;
  margin: 0 8px;
   background-color: ${
     $isDefaultAssembly
       ? theme.palette.brand.mediumGrey
       : theme.palette.primary.light
   };
  border-radius: 8px;
  border: 1px solid ${getEventBorderColor(
    theme,
    $isDefaultAssembly,
    $isSelected,
  )};

  &::before {
    content: "";
    width: 8px;
    height: 100%;
    background-color: ${
      $isDefaultAssembly
        ? theme.palette.brand.charcoal
        : theme.palette.primary.main
    };
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    position: absolute;
    top: 0;
    left: 8px;
  }

  &>p,
  &>a {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.7;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  a {
    text-decoration: none; 
    color: ${
      $isDefaultAssembly
        ? theme.palette.primary.lightest
        : theme.palette.brand.black
    };
  }
`,
);

export const OwnerOperatorOverrideStatusWrapper = styled(EventNameWrapper)(
  ({ theme }) => `
  background: ${theme.palette.success.main};
  border-radius: 0 0 5px 5px;
  min-height: 22px;

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.33;
  }
  a {
    text-decoration: none; 
    color: white;
  }
  `,
);

export const DaypartInfoLink = styled(Box)(
  ({ theme }) => `
  a {
    color: ${theme.palette.brand.black};
    text-decoration-color: ${theme.palette.brand.black};
  }
  `,
);

export const DaypartTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  margin-bottom: 10px;
`;

export const DefaultContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const OverridePill = styled(Box)(
  ({ theme }) => `
  width: 42px;
  min-height: 22px;
  background: ${theme.status.success.light};
  border-radius: 100px;
  justify-content: center;
  color: ${theme.palette.success.main};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  `,
);

export const StyledResourceWrapper = styled('span')`
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const Spinner = styled(CircularProgress)`
  display: none; /* Default hidden */
  position: absolute;
  top: 2%;
  left: 50%;

  &.active {
    display: flex; /* Show when class is added */
  }
`;

export const StyledPopover = styled(Popover)`
  margin-top: 8px;
`;

export const StyledPopupWrapper = styled(Box)`
  width: 450px;
  padding: 16px 24px 24px 24px;
  border-radius: 4px;
  margin-top: 8px;
`;

export const EventTitle = styled(Typography)(
  ({ theme, $isDefaultAssembly }) =>
    `
  font-weight: 500;
  font-size: 20px;
  line-height: 1.33;
  position: relative;
  padding-left: 8px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${theme.palette.grey[300]};
  margin-bottom: 24px;

  &:before {
    content: '';
    position: absolute;
    top: -4px;
    left: 0;
    width: 4px;
    height: 34px;
    background-color: ${
      $isDefaultAssembly
        ? theme.palette.brand.charcoal
        : theme.palette.primary.main
    };
    border-radius: 4px;
    display: flex;
  }
  `,
);

export const LightTypography = styled(Typography)`
  margin-top: 2px;
  font-weight: 300;
`;

export const RegularTypography = styled(Typography)`
  font-weight: 400;
`;

export const Caption = styled(Typography)`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  word-break: break-word;
`;

export const BottomSpacedStack = styled(Typography)`
  margin-bottom: 20px;
`;

export const NoDaypartImg = styled('img')`
  width: 200px;
  height: 161px;
`;

export const NoDaypartWrapper = styled(Box)(
  ({ theme }) => `
 display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 85%;
  margin-top:20px;
  border:1px solid  ${theme.palette.brand.borderGrey};
  border-radius:10px;
  `,
);
